


<ng-template ssMobileToolbarContent>
    <div class="flex-1 flex-row flex--align-center gap-standard">
        <button mat-icon-button (click)="back()"><mat-icon class="primary-contrast-text">arrow_back</mat-icon></button> 
        <h4 class="margin-none mat-headline-5 primary-contrast-text" >
            {{'ss-process-overview-detail.title'  | translate}}            
        </h4>
        
    </div>
    
</ng-template>

<mat-card class="full-height position-relative"  >
    <ss-core-loader-outlet [keys]="loaderKeysSubject | async"></ss-core-loader-outlet>
    <mat-card-header *ngIf="!(isSmallerScreenObs | async)" #cardHeader class="border-primary-bottom padding-standard flex-row flex--align-center flex--justify-between">
        <mat-card-title class="margin-none mat-headline-4" >
            {{'ss-process-overview-detail.title'  | translate}}
            <span class="primary-text-900">{{ (processSubject | async)?.description}}</span>
        </mat-card-title>
        <button mat-icon-button (click)="back()"><mat-icon>close</mat-icon></button>
    </mat-card-header>

    <mat-card-content class="padding-none" fixedScroll [otherElements]="[header,footer]">
        <ss-process-review  *ngIf="processIdSubject | async"
                            [processId]="processIdSubject | async"
                            [showTitle]="false"
        ></ss-process-review>
    </mat-card-content>


    <mat-card-footer 
        #footer 
        [ngClass]="{
            'flex-column':smallScreenSubject | async,
            'flex-row':!(smallScreenSubject | async),
            'border-primary-top':!(noMenuActionsSubject | async)
        }"
        class="gap-standard flex--align-center padding-standard border-primary-top"
    >
        
        <button [ngClass]="{'full-width':smallScreenSubject | async}"  *ngIf="(canSignSubject | async)" mat-raised-button class="primary-text" (click)="sign()">
            <mat-icon>edit</mat-icon>{{'ss-actions.sign' | translate}}
        </button>

        <button [ngClass]="{'full-width':smallScreenSubject | async}" *ngIf="canCancelSubject | async"   mat-raised-button class="error-text"   (click)="cancel()">
            <mat-icon>cancel</mat-icon><span>{{'ss-entities.process.actions.cancel.display' | translate}}</span>
        </button>
    
        <button  [ngClass]="{'full-width':smallScreenSubject | async}"*ngIf="canRejectSubject | async" mat-raised-button   class="error-text"   (click)="reject()">
            <mat-icon>warning</mat-icon><span>{{'ss-actions.reject' | translate}}</span>
        </button>
        
        <button [ngClass]="{'full-width':smallScreenSubject | async}"*ngIf="canDeleteSubject | async"  mat-raised-button   class="error-text"    (click)="deleteProcess()">
            <mat-icon>delete</mat-icon><span>{{'ss-actions.delete' | translate}}</span>
        </button>
        
        <button [ngClass]="{'full-width':smallScreenSubject | async}"*ngIf="canDownloadSubject | async" mat-raised-button color="primary"(click)="downloadDocuments()">
            <mat-icon>download</mat-icon><span>{{'ss-entities.process.actions.document-download.display' | translate}}</span>
        </button>
    
        <button [ngClass]="{'full-width':smallScreenSubject | async}" *ngIf="canDownloadAuditTrailSubject | async"  mat-raised-button color="primary" (click)="downloadAuditTrail()">
            <mat-icon>download</mat-icon><span>{{'ss-entities.process.actions.audit-trail.display' | translate}}</span>
        </button>

        <button [ngClass]="{'full-width':smallScreenSubject | async}" *ngIf="canRestartSubject | async"  mat-raised-button color="primary" (click)="restart()">
            <mat-icon>refresh</mat-icon><span>{{'ss-entities.process.actions.restart.display' | translate}}</span>
        </button>

        <button [ngClass]="{'full-width':smallScreenSubject | async}" *ngIf="canChangeValidTillSubject | async"  mat-raised-button color="primary" (click)="changeValidTill()">
            <mat-icon>edit_calendar</mat-icon>
            <span>{{'ss-entities.process.actions.change-valid-till.display' | translate}}</span>
        </button>

    </mat-card-footer>
    

</mat-card>